/** Auto-generated from EncycGames_International_Fitness_Programs workbook — do not hand-edit rows. */
/* eslint-disable */

export const FITNESS_PAGE_TITLE = 'Fitness Standards';

export const FITNESS_PAGE_SUBTITLE =
  'International fitness programs and consolidated skill/test inventory across countries and regions. These reference external standards that inform physical foundations; sport-specific skill and drill targets are developed separately.';

export const FITNESS_OVERVIEW_TITLE = "the multi-sport platform – International Fitness Programs";
export const FITNESS_OVERVIEW_INTRO = "Reference workbook | Existing programs inform physical foundations; the multi-sport platform separately develops sport-specific skill and drill targets.";
export const FITNESS_OVERVIEW_HEADERS: string[] = [
  "Country / region",
  "Program",
  "Age coverage",
  "Type",
  "Main tests / domains",
  "Values / scoring",
  "Platform reference use",
  "Official source"
];
export const FITNESS_OVERVIEW_ROWS: Record<string, string>[] = [
  {
    "Country / region": "United States",
    "Program": "Presidential Fitness Test / National Fitness Award",
    "Age coverage": "6–17+; upper limit of 17+ not stated",
    "Type": "T",
    "Main tests / domains": "Curl-ups or plank; mile or 20 m beep; push-ups or pull-ups",
    "Values / scoring": "National = solid achievement; Presidential = top tier; meet one target in each of three domains",
    "Platform reference use": "Reference verified results as general-fitness evidence only",
    "Official source": "https://www.whitehouse.gov/fitness/"
  },
  {
    "Country / region": "United States",
    "Program": "FitnessGram Healthy Fitness Zones",
    "Age coverage": "School age; age/sex criteria",
    "Type": "Z",
    "Main tests / domains": "PACER/mile; curl-up; trunk lift; push-up; sit-and-reach; body composition",
    "Values / scoring": "Healthy Fitness Zone, Needs Improvement, Needs Improvement–Health Risk",
    "Platform reference use": "Health-related feedback; not student-to-student ranking",
    "Official source": "https://www.cooperinstitute.org/youth/fitnessgram"
  },
  {
    "Country / region": "United States",
    "Program": "Presidential Youth Fitness Program",
    "Age coverage": "K–12 / school age",
    "Type": "G / Z",
    "Main tests / domains": "Health-related fitness and personal improvement; established assessments may be used",
    "Values / scoring": "Program guidance, not the new White House award table",
    "Platform reference use": "Keep separate from Presidential/National performance awards",
    "Official source": "https://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Country / region": "Europe",
    "Program": "EUROFIT",
    "Age coverage": "Primarily 6–18",
    "Type": "A",
    "Main tests / domains": "20 m shuttle; Flamingo; plate tapping; sit-reach; broad jump; grip; sit-ups; bent-arm hang; 10 × 5 m shuttle",
    "Values / scoring": "Raw measurements and profile/norm comparison; no single current Europe-wide pass tier",
    "Platform reference use": "Historical common battery; tests are measurements, not exercises",
    "Official source": "https://rm.coe.int/09000016809b5a02"
  },
  {
    "Country / region": "Europe",
    "Program": "ALPHA-Fitness / FitBack",
    "Age coverage": "Children and adolescents",
    "Type": "A",
    "Main tests / domains": "20 m shuttle; handgrip; standing long jump; BMI; waist; optional skinfold",
    "Values / scoring": "Health monitoring and reference feedback rather than universal award pass",
    "Platform reference use": "Modern health-monitoring reference with strict protocol",
    "Official source": "https://www.fitbackeurope.eu/en-us/Fitness-report/About-testing"
  },
  {
    "Country / region": "China",
    "Program": "National Student Physical Health Standard",
    "Age coverage": "Primary school through university (approximately 6–22)",
    "Type": "T",
    "Main tests / domains": "BMI; vital capacity; 50 m; sit-reach; jump/rope; pull-ups or sit-ups; 800/1000 m",
    "Values / scoring": "Excellent ≥90; Good 80–89.9; Pass 60–79.9; Fail <60; bonus may reach 120",
    "Platform reference use": "Useful stage progression; keep body data private and outside sport scoring",
    "Official source": "http://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html"
  },
  {
    "Country / region": "India",
    "Program": "Khelo India / SAI Fitness Assessment in Schools",
    "Age coverage": "5–8 and 9–18+",
    "Type": "A",
    "Main tests / domains": "5–8: BMI, Flamingo, plate tapping. 9+: BMI, 50 m, 600 m, sit-reach, partial curl-up, push-up variants",
    "Values / scoring": "Assessment/profile; complete universal public pass table not verified",
    "Platform reference use": "Strong early physical-literacy and school-assessment reference",
    "Official source": "https://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf"
  },
  {
    "Country / region": "Singapore",
    "Program": "NAPFA",
    "Age coverage": "Primary through pre-university; implementation varies",
    "Type": "T",
    "Main tests / domains": "Sit-ups; standing broad jump; sit-reach; inclined pull-ups/pull-ups; 4 × 10 m shuttle; 1.6/2.4 km",
    "Values / scoring": "Station grades and Gold/Silver/Bronze awards",
    "Platform reference use": "Use exact current school-stage scorecard",
    "Official source": "https://www.shps.moe.edu.sg/quick-links/for-students/permalink/"
  },
  {
    "Country / region": "Japan",
    "Program": "MEXT New Physical Fitness Test",
    "Age coverage": "6–11; 12–19; adult manual from 20",
    "Type": "T",
    "Main tests / domains": "Grip; 30 s trunk raises; sit-reach; side steps; shuttle/run; 50 m; long jump; throw",
    "Values / scoring": "Each event 1–10 points plus age/sex total-score grades A–E",
    "Platform reference use": "Strong multi-domain and U21 transition reference",
    "Official source": "https://www.mext.go.jp/a_menu/sports/stamina/03040901.htm"
  },
  {
    "Country / region": "Germany",
    "Program": "Deutsches Sportabzeichen",
    "Age coverage": "Youth 6–17; adult from 18",
    "Type": "T",
    "Main tests / domains": "One event each in endurance, strength, speed, coordination; swimming proof",
    "Values / scoring": "Event Bronze/Silver/Gold = 1/2/3 points; overall Bronze 4–7, Silver 8–10, Gold 11–12",
    "Platform reference use": "External-recognition model with authorised verification",
    "Official source": "https://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Country / region": "Canada",
    "Program": "Sport for Life – Long-Term Development 3.0",
    "Age coverage": "Childhood through adulthood; stage-based",
    "Type": "G",
    "Main tests / domains": "Physical literacy; multi-sport participation; progressive sport development; lifelong activity",
    "Values / scoring": "Development stages; not a numeric national fitness pass test",
    "Platform reference use": "Core LTAD reference for age- and stage-appropriate progression",
    "Official source": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/"
  },
  {
    "Country / region": "Australia",
    "Program": "24-hour Movement Guidelines + Australian Physical Literacy Framework",
    "Age coverage": "5–17; adult guidance from 18",
    "Type": "G",
    "Main tests / domains": "Daily activity; vigorous/muscle/bone activity; movement competence; physical literacy",
    "Values / scoring": "Recommended activity/development, not award-style fitness threshold",
    "Platform reference use": "Use for health and developmental context",
    "Official source": "https://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Country / region": "United Kingdom",
    "Program": "Chief Medical Officers’ Physical Activity Guidelines",
    "Age coverage": "5–18; separate adult guidance",
    "Type": "G",
    "Main tests / domains": "Average 60 minutes/day across week; variety; reduced sedentary time",
    "Values / scoring": "Population guidance, not performance battery",
    "Platform reference use": "Use for activity context, not sport-skill certification",
    "Official source": "https://www.gov.uk/government/publications/physical-activity-guidelines-uk-chief-medical-officers-report/uk-chief-medical-officers-physical-activity-guidelines"
  },
  {
    "Country / region": "International",
    "Program": "WHO Physical Activity Recommendations",
    "Age coverage": "5–17; adult guidance from 18",
    "Type": "G",
    "Main tests / domains": "Average 60 minutes/day moderate-to-vigorous activity; vigorous muscle/bone work ≥3 days/week",
    "Values / scoring": "Population health recommendation, not a one-day test",
    "Platform reference use": "Global health reference only",
    "Official source": "https://www.who.int/initiatives/behealthy/physical-activity"
  },
  {
    "Country / region": "Legend: T = published target | Z = health zone | A = assessment framework | G = guidance / LTAD | — = not a core component",
    "Program": "",
    "Age coverage": "",
    "Type": "",
    "Main tests / domains": "",
    "Values / scoring": "",
    "Platform reference use": "",
    "Official source": ""
  }
];

export const FITNESS_SKILLS_TITLE = "Detailed International Skill and Test Inventory";
export const FITNESS_SKILLS_INTRO = "Each test, measure, movement capability or development criterion is a separate row. The Master Domain is classification only; it does not merge or replace the explicit subdomains.";
export const FITNESS_SKILLS_HEADERS: string[] = [
  "Master domain",
  "Explicit subdomain / skill",
  "Named test or capability",
  "Reported unit / output",
  "US White House",
  "US FitnessGram / PYFP",
  "Europe EUROFIT",
  "Europe ALPHA / FitBack",
  "China NSPHS",
  "India Khelo India",
  "Singapore NAPFA",
  "Japan MEXT",
  "Germany DOSB",
  "Canada Sport for Life",
  "Australia",
  "United Kingdom",
  "WHO",
  "Official source URL(s)"
];
export const FITNESS_SKILLS_ROWS: Record<string, string>[] = [
  {
    "Master domain": "Anthropometry",
    "Explicit subdomain / skill": "Stature",
    "Named test or capability": "Standing height",
    "Reported unit / output": "cm",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Height",
    "Europe ALPHA / FitBack": "A Height; used with weight for BMI",
    "China NSPHS": "—",
    "India Khelo India": "A Height; used for BMI",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Growth and maturation monitoring",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02\nhttps://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf\nhttps://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/"
  },
  {
    "Master domain": "Anthropometry",
    "Explicit subdomain / skill": "Body mass",
    "Named test or capability": "Body weight",
    "Reported unit / output": "kg",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Weight",
    "Europe ALPHA / FitBack": "A Weight; used with height for BMI",
    "China NSPHS": "—",
    "India Khelo India": "A Weight; used for BMI",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Growth and maturation monitoring",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02\nhttps://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf\nhttps://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/"
  },
  {
    "Master domain": "Body composition",
    "Explicit subdomain / skill": "Weight relative to height",
    "Named test or capability": "Body Mass Index (BMI)",
    "Reported unit / output": "kg/m²; age/sex interpretation",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z BMI option / Healthy Fitness Zone",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "A BMI",
    "China NSPHS": "T BMI; weighted national score",
    "India Khelo India": "A BMI",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "G Health context; not a youth performance award",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing\nhttp://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Body composition",
    "Explicit subdomain / skill": "Central adiposity",
    "Named test or capability": "Waist circumference",
    "Reported unit / output": "cm",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "A Waist circumference",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "G Health context only",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Body composition",
    "Explicit subdomain / skill": "Subcutaneous fat",
    "Named test or capability": "Skinfold thickness",
    "Reported unit / output": "mm",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z Skinfold/body-fat option",
    "Europe EUROFIT": "A Five skinfolds for survey/profile",
    "Europe ALPHA / FitBack": "A Optional skinfolds",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://rm.coe.int/09000016809b5a02\nhttps://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing"
  },
  {
    "Master domain": "Physiological function",
    "Explicit subdomain / skill": "Respiratory function",
    "Named test or capability": "Vital capacity",
    "Reported unit / output": "mL",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T Vital capacity; weighted national score",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "http://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Progressive shuttle endurance",
    "Named test or capability": "20 m beep / shuttle run",
    "Reported unit / output": "laps, stages or last half-stage",
    "US White House": "T National/Presidential examples: age 6 B 10/27, G 10/22; age 17+ B 50/84, G 28/50 laps",
    "US FitnessGram / PYFP": "Z 20 m PACER option; age/sex Healthy Fitness Zone",
    "Europe EUROFIT": "A 20 m endurance shuttle; maximal progressive",
    "Europe ALPHA / FitBack": "A 20 m shuttle; final test in sequence",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "T examples (10/5/1 points): ages 6–11 B ≥80 / 23–32 / ≤7; G ≥64 / 19–25 / ≤7",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Aerobic development by stage",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.whitehouse.gov/fitness/\nhttps://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://rm.coe.int/09000016809b5a02\nhttps://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing\nhttps://www.mext.go.jp/a_menu/sports/stamina/03040901.htm\nhttps://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Shorter progressive shuttle",
    "Named test or capability": "15 m PACER",
    "Reported unit / output": "laps",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z 15 m PACER option where adopted",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Continuous distance run",
    "Named test or capability": "One-mile run",
    "Reported unit / output": "min:s",
    "US White House": "T National/Presidential examples: age 6 B 12:36/10:15, G 13:12/11:20; age 17+ B 7:04/6:06, G 9:58/7:59",
    "US FitnessGram / PYFP": "Z One-mile run option; age/sex Healthy Fitness Zone",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.whitehouse.gov/fitness/\nhttps://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Continuous distance walk",
    "Named test or capability": "One-mile walk",
    "Reported unit / output": "time + heart rate / estimated aerobic capacity",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z One-mile walk option in relevant implementations",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Middle-distance run/walk",
    "Named test or capability": "600 m run/walk",
    "Reported unit / output": "min:s",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "A 600 m run/walk, ages 9+",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Middle-distance run",
    "Named test or capability": "800 m run",
    "Reported unit / output": "min:s",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T examples 100/60 points: Middle 1 girls 3:35/4:55; University years 1–2 women 3:18/4:34",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Bronze/Silver/Gold examples: girls 6–7 5:40/5:00/4:15; girls 16–17 4:50/4:05/3:25; boys 16–17 4:05/3:25/2:45",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "http://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Middle-distance run",
    "Named test or capability": "1000 m run",
    "Reported unit / output": "min:s",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T examples 100/60 points: Middle 1 boys 3:55/5:20; University years 1–2 men 3:17/4:27",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Approved endurance event by age/stage; see current catalogue",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "http://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Distance run",
    "Named test or capability": "1.6 km run",
    "Reported unit / output": "min:s",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "T NAPFA endurance distance for applicable younger groups",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.shps.moe.edu.sg/quick-links/for-students/permalink/"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Distance run",
    "Named test or capability": "2.4 km run",
    "Reported unit / output": "min:s",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "T NAPFA endurance distance for applicable groups",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.shps.moe.edu.sg/quick-links/for-students/permalink/"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Longer endurance choices",
    "Named test or capability": "Run / Nordic walking / cycling choices",
    "Reported unit / output": "time or distance",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Choose an approved endurance event for age/sex tier",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Cardiorespiratory endurance",
    "Explicit subdomain / skill": "Cycle-based aerobic capacity",
    "Named test or capability": "PWC170 bicycle ergometer",
    "Reported unit / output": "work rate at HR 170",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Alternative laboratory/indoor endurance test",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02"
  },
  {
    "Master domain": "Core muscular endurance",
    "Explicit subdomain / skill": "Abdominal endurance",
    "Named test or capability": "Curl-ups in 1 minute",
    "Reported unit / output": "repetitions",
    "US White House": "T National/Presidential examples: age 6 B 22/33, G 23/32; age 17+ B 45/57, G 37/48",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.whitehouse.gov/fitness/"
  },
  {
    "Master domain": "Core muscular endurance",
    "Explicit subdomain / skill": "Cadenced abdominal endurance",
    "Named test or capability": "Partial curl-up / curl-up",
    "Reported unit / output": "repetitions at protocol cadence",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z Curl-up Healthy Fitness Zone",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "A Partial curl-ups, ages 9+",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf"
  },
  {
    "Master domain": "Core muscular endurance",
    "Explicit subdomain / skill": "Trunk endurance",
    "Named test or capability": "30-second sit-ups / trunk raises",
    "Reported unit / output": "repetitions in 30 s",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Sit-ups in 30 s",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "T Upper-body raising in 30 s; 1–10 points",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02\nhttps://www.mext.go.jp/a_menu/sports/stamina/03040901.htm"
  },
  {
    "Master domain": "Core muscular endurance",
    "Explicit subdomain / skill": "Abdominal endurance",
    "Named test or capability": "One-minute sit-ups",
    "Reported unit / output": "repetitions in 1 min",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T example University years 1–2 women: 56 reps = 100 points; 26 = 60 points",
    "India Khelo India": "—",
    "Singapore NAPFA": "T Sit-ups station; age/sex station grade tables",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "http://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://www.shps.moe.edu.sg/quick-links/for-students/permalink/"
  },
  {
    "Master domain": "Core isometric endurance",
    "Explicit subdomain / skill": "Anterior core hold",
    "Named test or capability": "Plank hold",
    "Reported unit / output": "seconds",
    "US White House": "T National/Presidential examples: age 6 B 42/73, G 41/71; age 17+ B 98/156, G 79/145",
    "US FitnessGram / PYFP": "Z New/available plank item",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.whitehouse.gov/fitness/\nhttps://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Trunk strength and mobility",
    "Explicit subdomain / skill": "Trunk extension",
    "Named test or capability": "Trunk lift",
    "Reported unit / output": "cm / protocol limit",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z Trunk lift Healthy Fitness Zone",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Upper-body strength/endurance",
    "Explicit subdomain / skill": "Horizontal pushing endurance",
    "Named test or capability": "Right-angle push-ups",
    "Reported unit / output": "repetitions",
    "US White House": "T National/Presidential examples: age 6 B 7/9, G 6/9; age 17+ B 37/53, G 16/25",
    "US FitnessGram / PYFP": "Z Push-up Healthy Fitness Zone",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "A Full push-ups for applicable groups",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.whitehouse.gov/fitness/\nhttps://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf"
  },
  {
    "Master domain": "Upper-body strength/endurance",
    "Explicit subdomain / skill": "Modified pushing endurance",
    "Named test or capability": "Modified push-ups",
    "Reported unit / output": "repetitions",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "A Modified push-up variant for applicable groups",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf"
  },
  {
    "Master domain": "Upper-body strength/endurance",
    "Explicit subdomain / skill": "Vertical pulling strength",
    "Named test or capability": "Pull-ups / chin-ups",
    "Reported unit / output": "repetitions",
    "US White House": "T National/Presidential examples: age 6 B/G 1/2; age 17+ B 8/13, G 1/3",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T example University years 1–2 men: 19 reps = 100 points; 10 = 60 points",
    "India Khelo India": "—",
    "Singapore NAPFA": "T Pull-ups for applicable groups; age/sex station grade tables",
    "Japan MEXT": "—",
    "Germany DOSB": "T Pull-up/chin-up choices in strength category",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.whitehouse.gov/fitness/\nhttp://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://www.shps.moe.edu.sg/quick-links/for-students/permalink/\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Upper-body strength/endurance",
    "Explicit subdomain / skill": "Inclined pulling endurance",
    "Named test or capability": "Inclined pull-ups",
    "Reported unit / output": "repetitions",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "T Inclined pull-ups for applicable groups",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.shps.moe.edu.sg/quick-links/for-students/permalink/"
  },
  {
    "Master domain": "Upper-body strength/endurance",
    "Explicit subdomain / skill": "Modified pulling endurance",
    "Named test or capability": "Modified pull-ups",
    "Reported unit / output": "repetitions",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z Modified pull-up option",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Upper-body strength/endurance",
    "Explicit subdomain / skill": "Isometric flexed-arm endurance",
    "Named test or capability": "Flexed-arm hang",
    "Reported unit / output": "seconds",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z Flexed-arm hang option",
    "Europe EUROFIT": "A Bent-arm hang / functional strength",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://rm.coe.int/09000016809b5a02"
  },
  {
    "Master domain": "Static strength",
    "Explicit subdomain / skill": "Hand and forearm strength",
    "Named test or capability": "Handgrip dynamometer",
    "Reported unit / output": "kg or N",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z New/available handgrip item",
    "Europe EUROFIT": "A Best handgrip force",
    "Europe ALPHA / FitBack": "A Handgrip; two attempts per hand",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "T Handgrip; 1–10 points",
    "Germany DOSB": "T Strength-category option in relevant catalogue",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://rm.coe.int/09000016809b5a02\nhttps://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing\nhttps://www.mext.go.jp/a_menu/sports/stamina/03040901.htm\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Flexibility",
    "Explicit subdomain / skill": "Posterior-chain flexibility",
    "Named test or capability": "Sit-and-reach",
    "Reported unit / output": "cm",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Sit-and-reach",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T Sit-and-reach; national points",
    "India Khelo India": "A Sit-and-reach, ages 9+",
    "Singapore NAPFA": "T Sit-and-reach station",
    "Japan MEXT": "T Long-seated forward bend; 1–10 points",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02\nhttp://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf\nhttps://www.shps.moe.edu.sg/quick-links/for-students/permalink/\nhttps://www.mext.go.jp/a_menu/sports/stamina/03040901.htm"
  },
  {
    "Master domain": "Flexibility",
    "Explicit subdomain / skill": "Unilateral hamstring flexibility",
    "Named test or capability": "Back-saver sit-and-reach",
    "Reported unit / output": "cm each side",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z Back-saver sit-and-reach option",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Flexibility",
    "Explicit subdomain / skill": "Shoulder mobility",
    "Named test or capability": "Shoulder stretch",
    "Reported unit / output": "pass/fail each side",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z Shoulder-stretch option",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program"
  },
  {
    "Master domain": "Running speed",
    "Explicit subdomain / skill": "Acceleration / short sprint",
    "Named test or capability": "30 m sprint",
    "Reported unit / output": "seconds",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Bronze/Silver/Gold examples age 6–7: girls 8.0/7.1/6.3 s; boys 7.7/6.8/6.0 s",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Running speed",
    "Explicit subdomain / skill": "Linear sprint",
    "Named test or capability": "50 m sprint",
    "Reported unit / output": "seconds",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T Primary 1 examples 100/60 points: boys 10.2/12.6 s; girls 11.0/13.8 s",
    "India Khelo India": "A 50 m sprint, ages 9+",
    "Singapore NAPFA": "—",
    "Japan MEXT": "T ages 6–11 examples (10/5/1 points): B ≤8.0 / 10.0–10.6 / ≥13.1; G ≤8.3 / 10.3–10.9 / ≥13.3 s",
    "Germany DOSB": "T 50 m speed event for applicable ages; see age/sex catalogue",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "http://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf\nhttps://www.mext.go.jp/a_menu/sports/stamina/03040901.htm\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Running speed",
    "Explicit subdomain / skill": "Linear sprint",
    "Named test or capability": "100 m sprint",
    "Reported unit / output": "seconds",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Bronze/Silver/Gold examples age 16–17: girls 17.6/16.3/15.0 s; boys 16.3/14.8/13.5 s",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Agility / change of direction",
    "Explicit subdomain / skill": "Repeated short shuttle",
    "Named test or capability": "4 × 10 m shuttle run",
    "Reported unit / output": "seconds",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "T 4 × 10 m shuttle station",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.shps.moe.edu.sg/quick-links/for-students/permalink/"
  },
  {
    "Master domain": "Agility / change of direction",
    "Explicit subdomain / skill": "Repeated short shuttle",
    "Named test or capability": "10 × 5 m shuttle run",
    "Reported unit / output": "seconds",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Running speed/agility test",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02"
  },
  {
    "Master domain": "Agility / lateral movement",
    "Explicit subdomain / skill": "Rapid lateral stepping",
    "Named test or capability": "Side-step test",
    "Reported unit / output": "crossings / points",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "T Repeated side steps; 1–10 points",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.mext.go.jp/a_menu/sports/stamina/03040901.htm"
  },
  {
    "Master domain": "Limb movement speed",
    "Explicit subdomain / skill": "Upper-limb cyclic speed",
    "Named test or capability": "Plate tapping",
    "Reported unit / output": "seconds for 25 cycles",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Plate tapping",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "A Plate tapping, ages 5–8",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf"
  },
  {
    "Master domain": "Lower-body explosive power",
    "Explicit subdomain / skill": "Horizontal bilateral jump",
    "Named test or capability": "Standing broad / long jump",
    "Reported unit / output": "cm",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Standing broad jump; best of two in cm",
    "Europe ALPHA / FitBack": "A Standing long jump; best of two",
    "China NSPHS": "T Standing long jump for specified groups; national points",
    "India Khelo India": "—",
    "Singapore NAPFA": "T Standing broad jump station; age/sex grades",
    "Japan MEXT": "T ages 12–19 examples (10/5/1 points): B ≥265 / 203–217 / ≤149; G ≥210 / 157–167 / ≤117 cm",
    "Germany DOSB": "T Bronze/Silver/Gold examples: age 6–7 G 105/125/140, B 115/135/150; age 16–17 G 165/180/200, B 205/220/240 cm",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02\nhttps://pubmed.ncbi.nlm.nih.gov/20961915/\nhttps://www.fitbackeurope.eu/en-us/Fitness-report/About-testing\nhttp://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://www.shps.moe.edu.sg/quick-links/for-students/permalink/\nhttps://www.mext.go.jp/a_menu/sports/stamina/03040901.htm\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Lower-body explosive power",
    "Explicit subdomain / skill": "Vertical jump",
    "Named test or capability": "Vertical jump",
    "Reported unit / output": "cm",
    "US White House": "—",
    "US FitnessGram / PYFP": "Z New/available power item",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T High-jump/vertical power choices in catalogue",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.cooperinstitute.org/youth/fitnessgram\nhttps://odphp.health.gov/pcsfn/programs-awards/presidential-youth-fitness-program\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Balance",
    "Explicit subdomain / skill": "Static single-leg balance",
    "Named test or capability": "Flamingo balance",
    "Reported unit / output": "falls / attempts in 60 s",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "A Flamingo balance",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "A Flamingo balance, ages 5–8",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://rm.coe.int/09000016809b5a02\nhttps://www.kheloindia.gov.in/uploads/rfe-for-fitness-assessment-1604488852.pdf"
  },
  {
    "Master domain": "Coordination",
    "Explicit subdomain / skill": "Jump-rope coordination",
    "Named test or capability": "Timed rope skipping",
    "Reported unit / output": "repetitions",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "T One-minute rope skipping in primary stages",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Rope-skipping coordination choices",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "http://www.moe.gov.cn/s78/A17/twys_left/moe_938/moe_792/s3273/201407/t20140708_171692.html\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Object-control skill",
    "Explicit subdomain / skill": "Overarm throwing power",
    "Named test or capability": "Softball / ball throw",
    "Reported unit / output": "metres",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "T Handball/softball throw by age group; 1–10 points",
    "Germany DOSB": "T Throwing choices in coordination/strength categories",
    "Canada Sport for Life": "G Fundamental throw before sport-specific refinement",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://www.mext.go.jp/a_menu/sports/stamina/03040901.htm\nhttps://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf\nhttps://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/"
  },
  {
    "Master domain": "Object-control skill",
    "Explicit subdomain / skill": "Receiving an object",
    "Named test or capability": "Catch",
    "Reported unit / output": "movement competence / developmental observation",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental movement skill",
    "Australia": "G Object-control movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Object-control skill",
    "Explicit subdomain / skill": "Foot-based object control",
    "Named test or capability": "Kick",
    "Reported unit / output": "movement competence / developmental observation",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental movement / sport skill",
    "Australia": "G Object-control movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Object-control skill",
    "Explicit subdomain / skill": "Hand/implement propulsion",
    "Named test or capability": "Strike",
    "Reported unit / output": "movement competence / developmental observation",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental sport skill",
    "Australia": "G Object-control movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Object-control skill",
    "Explicit subdomain / skill": "Continuous object control",
    "Named test or capability": "Dribble",
    "Reported unit / output": "movement competence / developmental observation",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental sport skill",
    "Australia": "G Object-control movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Locomotor competence",
    "Explicit subdomain / skill": "Basic locomotion",
    "Named test or capability": "Run",
    "Reported unit / output": "movement quality / competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental movement skill",
    "Australia": "G Movement competence",
    "United Kingdom": "G Varied movement across the week",
    "WHO": "G Moderate-to-vigorous activity context",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years\nhttps://www.gov.uk/government/publications/physical-activity-guidelines-uk-chief-medical-officers-report/uk-chief-medical-officers-physical-activity-guidelines\nhttps://www.who.int/initiatives/behealthy/physical-activity"
  },
  {
    "Master domain": "Locomotor competence",
    "Explicit subdomain / skill": "Horizontal take-off and landing",
    "Named test or capability": "Jump",
    "Reported unit / output": "movement quality / competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental movement skill",
    "Australia": "G Movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Locomotor competence",
    "Explicit subdomain / skill": "Single-leg take-off and landing",
    "Named test or capability": "Hop",
    "Reported unit / output": "movement quality / competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental movement skill",
    "Australia": "G Movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Locomotor competence",
    "Explicit subdomain / skill": "Rhythmic alternating locomotion",
    "Named test or capability": "Skip",
    "Reported unit / output": "movement quality / competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental movement skill",
    "Australia": "G Movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Locomotor competence",
    "Explicit subdomain / skill": "Multi-directional locomotion",
    "Named test or capability": "Gallop / slide",
    "Reported unit / output": "movement quality / competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fundamental movement skill",
    "Australia": "G Movement competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Aquatic competence",
    "Explicit subdomain / skill": "Water safety prerequisite",
    "Named test or capability": "Proof of swimming ability",
    "Reported unit / output": "verified demonstration",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Swimming proof required for award",
    "Canada Sport for Life": "G Water is one of four physical-literacy environments",
    "Australia": "G Aquatic competence / safe participation context",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf\nhttps://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Aquatic performance",
    "Explicit subdomain / skill": "Swim speed/endurance",
    "Named test or capability": "Approved swim events",
    "Reported unit / output": "seconds or distance",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "T Approved swimming events can satisfy categories",
    "Canada Sport for Life": "—",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://cdn.dosb.de/Relaunch_2024/Sportabzeichen/Materialien_2026/ONE8Y_DSA_Leistungsuebersicht_KiJu_A3_2025_Querformat_RGB.pdf"
  },
  {
    "Master domain": "Physical-activity behaviour",
    "Explicit subdomain / skill": "Daily moderate-to-vigorous activity",
    "Named test or capability": "Average activity across week",
    "Reported unit / output": "minutes/day",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "G At least 60 min/day moderate-to-vigorous activity",
    "United Kingdom": "G Average at least 60 min/day across week",
    "WHO": "G Average at least 60 min/day moderate-to-vigorous activity",
    "Official source URL(s)": "https://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years\nhttps://www.gov.uk/government/publications/physical-activity-guidelines-uk-chief-medical-officers-report/uk-chief-medical-officers-physical-activity-guidelines\nhttps://www.who.int/initiatives/behealthy/physical-activity"
  },
  {
    "Master domain": "Physical-activity behaviour",
    "Explicit subdomain / skill": "Vigorous aerobic activity",
    "Named test or capability": "Vigorous activity frequency",
    "Reported unit / output": "days/week",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "G Vigorous activity at least 3 days/week",
    "United Kingdom": "—",
    "WHO": "G Vigorous aerobic activity at least 3 days/week",
    "Official source URL(s)": "https://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years\nhttps://www.who.int/initiatives/behealthy/physical-activity"
  },
  {
    "Master domain": "Physical-activity behaviour",
    "Explicit subdomain / skill": "Muscle and bone strengthening",
    "Named test or capability": "Strengthening activity frequency",
    "Reported unit / output": "days/week",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "G Muscle/bone strengthening at least 3 days/week",
    "United Kingdom": "G Develop muscle and bone strength across week",
    "WHO": "G Muscle/bone strengthening at least 3 days/week",
    "Official source URL(s)": "https://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years\nhttps://www.gov.uk/government/publications/physical-activity-guidelines-uk-chief-medical-officers-report/uk-chief-medical-officers-physical-activity-guidelines\nhttps://www.who.int/initiatives/behealthy/physical-activity"
  },
  {
    "Master domain": "Physical-activity behaviour",
    "Explicit subdomain / skill": "Sedentary behaviour",
    "Named test or capability": "Recreational screen/sitting limitation",
    "Reported unit / output": "time / behaviour guidance",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "—",
    "Australia": "G Limit sedentary recreational screen time",
    "United Kingdom": "G Minimise extended sedentary periods",
    "WHO": "G Limit sedentary time",
    "Official source URL(s)": "https://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years\nhttps://www.gov.uk/government/publications/physical-activity-guidelines-uk-chief-medical-officers-report/uk-chief-medical-officers-physical-activity-guidelines\nhttps://www.who.int/initiatives/behealthy/physical-activity"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Agility",
    "Named test or capability": "ABCs of athleticism – agility",
    "Reported unit / output": "developmental competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Core FUNdamentals emphasis",
    "Australia": "G Physical-domain competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Balance",
    "Named test or capability": "ABCs of athleticism – balance",
    "Reported unit / output": "developmental competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Core FUNdamentals emphasis",
    "Australia": "G Physical-domain competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Coordination",
    "Named test or capability": "ABCs of athleticism – coordination",
    "Reported unit / output": "developmental competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Core FUNdamentals emphasis",
    "Australia": "G Physical-domain competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Speed",
    "Named test or capability": "ABCs of athleticism – speed",
    "Reported unit / output": "developmental competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Core FUNdamentals emphasis",
    "Australia": "G Physical-domain competence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Rhythm and expression",
    "Named test or capability": "Dance / rhythmic movement",
    "Reported unit / output": "movement competence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Physical literacy includes rhythmic/dance situations",
    "Australia": "G Movement competence and confidence",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Environmental adaptability",
    "Named test or capability": "Ground / water / snow-ice / air",
    "Reported unit / output": "competence across environments",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Four physical-literacy environments",
    "Australia": "G Adapt movement across settings",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Motivation and confidence",
    "Named test or capability": "Willingness and confidence to participate",
    "Reported unit / output": "qualitative / questionnaire",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Confidence and motivation support participation",
    "Australia": "G Psychological domain",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Knowledge and understanding",
    "Named test or capability": "Rules, safety, tactics and value of activity",
    "Reported unit / output": "qualitative / curriculum evidence",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Read and react to activity situations",
    "Australia": "G Cognitive domain",
    "United Kingdom": "G Understand activity benefits and safe participation",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years\nhttps://www.gov.uk/government/publications/physical-activity-guidelines-uk-chief-medical-officers-report/uk-chief-medical-officers-physical-activity-guidelines"
  },
  {
    "Master domain": "Physical literacy",
    "Explicit subdomain / skill": "Social capability",
    "Named test or capability": "Cooperation, communication and fair play",
    "Reported unit / output": "qualitative / observation",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fair play and ethics",
    "Australia": "G Social domain",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years"
  },
  {
    "Master domain": "Development pathway",
    "Explicit subdomain / skill": "Multi-sport participation",
    "Named test or capability": "Exposure to varied sports and activities",
    "Reported unit / output": "participation profile",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Fun, inclusive, multisport early stages",
    "Australia": "G Varied movement experiences",
    "United Kingdom": "G Variety of activity types",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/\nhttps://www.health.gov.au/topics/physical-activity-and-exercise/physical-activity-and-exercise-guidelines-for-all-australians/recommendations-for-children-and-young-people-5-to-17-years\nhttps://www.gov.uk/government/publications/physical-activity-guidelines-uk-chief-medical-officers-report/uk-chief-medical-officers-physical-activity-guidelines"
  },
  {
    "Master domain": "Development pathway",
    "Explicit subdomain / skill": "Stage-appropriate progression",
    "Named test or capability": "Active Start → FUNdamentals → Learn/Train stages",
    "Reported unit / output": "development stage",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Long-Term Development stages",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/"
  },
  {
    "Master domain": "Development pathway",
    "Explicit subdomain / skill": "Growth and maturation",
    "Named test or capability": "Peak-height-velocity / maturation monitoring",
    "Reported unit / output": "developmental observation",
    "US White House": "—",
    "US FitnessGram / PYFP": "—",
    "Europe EUROFIT": "—",
    "Europe ALPHA / FitBack": "—",
    "China NSPHS": "—",
    "India Khelo India": "—",
    "Singapore NAPFA": "—",
    "Japan MEXT": "—",
    "Germany DOSB": "—",
    "Canada Sport for Life": "G Training response and growth monitoring",
    "Australia": "—",
    "United Kingdom": "—",
    "WHO": "—",
    "Official source URL(s)": "https://sportforlife.ca/portfolio-item/long-term-development-in-sport-and-physical-activity-3-0/"
  }
];
